import { BasePerimeter } from '.'

export default new BasePerimeter({
  purpose: 'route',
  can: {
    route: () => true,
    read() {
      return this.isAuthenticated()
    }
  }
})
